export default "__VITE_ASSET__8a86c403__"